import { combineEpics, ofType } from 'redux-observable';
import { map, scan, filter } from 'rxjs/operators';
import path from 'ramda/src/path';
import { initAxios } from 'utils';
import { store } from 'index';
import i18n from '../i18n';

const noop = () => ({ type: 'NOOP' });

const loginEpic = action$ =>
  action$.pipe(
    ofType('SMS_FORM_SENDING_SUCCESS'),
    map(response => {
      localStorage.setItem('token', response.payload.token);
      localStorage.setItem('public', response.payload.hash);
      initAxios(response.payload.token);
    }),
    map(payload => ({ ...payload, type: 'USER_LOGIN' }))
  );

const initEpic = action$ =>
  action$.pipe(
    ofType('INIT_APP'),
    map(
      () => {
        let token = '';
        try {
          token = localStorage.getItem('token');
        } catch (e) {
        }
        if (token) {
          initAxios(token);
        }
      }),
    map(noop)
  );

const logoutEpic = action$ =>
  action$.pipe(
    ofType('USER_LOGOUT_SUCCESS'),
    map(
    () => {
      localStorage.removeItem('token');
      initAxios();
    }
    ),
    map(noop)
  );

const notificationEpicCreator = ({ type, hide = false, status, message, filter1 = _ => _ }) => action$ =>
  action$.pipe(
    ofType(
      ...(Array.isArray(type) ? type : [type]) // accept several types
    ),
    filter(
      filter1
    ),
    map(
      a => ({
        type: hide ? 'HIDE_NOTIFICATION' : 'SHOW_NOTIFICATION',
        payload: {
          message: typeof message === 'function' ? message(a, store.getState()) : message,
          cancel: path(['meta', 'cancel'], a),
          status
        }
      })
    )
  );

const getCollectionMessage = ({
  prevCount,
  buildingName,
  collectionName
}) => {
  const name = buildingName || i18n.t('common.jk');
  if (Math.abs(prevCount) > 1) {
    return prevCount > 0
      ? i18n.t('epics.addedToCollections1', { buildingName: name })
      : i18n.t('epics.removeFromCollections1', { buildingName: name });
  }

  return prevCount > 0
    ? i18n.t('epics.addedToCollections2', { buildingName: name, collectionName })
    : i18n.t('epics.removeFromCollections2', { buildingName: name, collectionName });
};
const collectionNotificationEpicCreator = () => action$ =>
  action$.pipe(
    ofType(
      'ADD_TO_COLLECTION_SUCCESS',
      'REMOVE_FROM_COLLECTION_SUCCESS',
      'CLOSE_COLLECTIONS_DIALOG',
      'CANCELATION_SUCCESS'
    ),
    scan(
      (data, action) => (
        action.type === 'CLOSE_COLLECTIONS_DIALOG' ||
        action.type === 'CANCELATION_SUCCESS'
      ) ? {
        ...data,
        ...action,
        count: 0,
        prevCount: data.count,
        finished: true,
        cancel: data.count < 0 ? data.cancel : null
      } : {
        ...data,
        ...action,
        count: data.count + (action.type === 'ADD_TO_COLLECTION_SUCCESS' ? 1 : -1),
        prevCount: data.count,
        cancel: (data.finished ? [] : data.cancel).concat(path(['meta', 'cancel'], action)),
        finished: false
      }
      ,
      { count: 0, prevCount: 0, meta: {}, finished: true }
    ),
    filter(
      action => (
        action.type === 'CLOSE_COLLECTIONS_DIALOG' ||
        action.type === 'CANCELATION_SUCCESS'
      )
    ),
    map(
    ({ prevCount, cancel, meta: { buildingName = null, collectionName } }) => (
      Math.abs(prevCount) > 0 ?
      {
        type: 'SHOW_NOTIFICATION',
        payload: {
          message: getCollectionMessage({ buildingName, prevCount, collectionName }),
          status: prevCount < 0 ? 1 : 0,
          cancel
        }
      } : noop
    )
  )
);
//   ({meta: {buildingName, collectionName}}) => (
//     action$.ofType('CLOSE_COLLECTIONS_DIALOG').map(
//       () => ({
//         type: 'SHOW_NOTIFICATION',
//         payload: {
//           message: `${buildingName || 'ЖК'} ${act}`
//         }
//       })
//     )
//   )
// )


const rootEpic = combineEpics(
  initEpic,
  loginEpic,
  logoutEpic,
  combineEpics(...[
    {
      type: '@@redux-form/SET_SUBMIT_FAILED',
      filter: a => path(['meta', 'form'])(a) === 'ProfileForm',
      message: (action, state) => {
        const { firstName, lastName, email, phone, position } = path(['form', 'ProfileForm', 'values'], state) || {};
        if (!firstName || !lastName || !email || !phone || !position) {
          return i18n.t('epics.emptyFieldsError');
        }
        return i18n.t('epics.fieldsError');
      },
      status: 1
    },
    {
      type: '@@redux-form/SET_SUBMIT_FAILED',
      filter: a => path(['meta', 'form'])(a) === 'CompanyForm',
      message: (action, state) => {
        const values = path(['form', 'CompanyForm', 'values'], state) || {};
        const requiredKeys = Object.keys(values).filter(
            key => key === 'name' || key.includes('office')
          );
        if (requiredKeys.some(key => !key)) {
          return i18n.t('epics.emptyFieldsError');
        }
        return i18n.t('epics.fieldsError');
      },
      status: 1
    },
    {
      type: '@@redux-form/UPDATE_SYNC_ERRORS',
      filter: a => Object.values(path(['meta', 'form'], a)).length,
      hide: true
    },
    {
      type: 'CHECK_BUILDING_START',
      hide: true
    },
    {
      type: 'SET_POPUP',
      filter: a => !a.popUp,
      hide: true
    },
    {
      type: ['UPDATE_PROFILE_OK', 'UPDATE_AGENT_PROFILE_OK', 'UPDATE_COMPANY_OK'],
      message: i18n.t('epics.savedInfo')
    },
    {
      type: 'DELETE_COLLECTION_SUCCESS',
      message: i18n.t('epics.deletedCollection'),
      status: 1
    },
    {
      type: 'REMOVE_FROM_FAVORITES_SUCCESS',
      message: ({ meta: { buildingName } }) => i18n.t('epics.deleteFromFavorites', { buildingName: buildingName || i18n.t('common.jk') }),
      status: 1
    },
    {
      type: 'REMOVE_FROM_COLLECTION_SUCCESS',
      message: ({ meta: { buildingName, collectionName } }) => i18n.t('epics.removeFromCollections2', { buildingName: buildingName || i18n.t('common.jk'), collectionName }),
      status: 1
    },
    {
      type: 'ADD_TO_COLLECTION_SUCCESS',
      filter: a => !path(['meta', 'cancelation'], a),
      message: ({ meta: { buildingName, collectionName } }) => i18n.t('epics.addedToCollections2', { buildingName: buildingName || i18n.t('common.jk'), collectionName })
    },
    {
      type: 'ADD_TO_FAVORITES_SUCCESS',
      message: ({ meta: { buildingName } }) => i18n.t('epics.addedToFavorites', { buildingName: buildingName || i18n.t('common.jk') })
    }
  ].map(notificationEpicCreator)),
  collectionNotificationEpicCreator(),
);

export default rootEpic;



// WEBPACK FOOTER //
// ./src/epics/index.js